module.exports = __webpack_public_path__ + "img/hs_hori_logo_blue.57ad2bcd.png";